import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminMe, clearToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);      // {id, email, name, role, capabilities}
  const [checking, setChecking] = useState(!!getToken());

  const refreshMe = useCallback(async () => {
    if (!getToken()) { setUser(null); setChecking(false); return null; }
    try {
      const me = await adminMe();
      setUser(me);
      return me;
    } catch {
      setUser(null);
      return null;
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => { refreshMe(); }, [refreshMe]);

  const logout = () => { clearToken(); setUser(null); };

  const can = (cap) => !!user?.capabilities?.includes(cap);
  const isSuperAdmin = user?.role === "super_admin";

  return (
    <AuthContext.Provider value={{ user, setUser, refreshMe, checking, logout, can, isSuperAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
